import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import ChannelLive from "./pages/ChannelLive";
import Channels from "./pages/Channels";
import Watch from "./pages/Watch";
import Browse from "./pages/Browse";
import Admin from "./pages/Admin";
import Partners from "./pages/Partners";
import Membership from "./pages/Membership";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogTop from "./pages/BlogTop";
import BlogArticle from "./pages/BlogArticle";
import ShortsPlayer from "./pages/ShortsPlayer";
import Trending from "./pages/Trending";
import Battle from "./pages/Battle";
import LiveStream from "./pages/LiveStream";
import ProgramGuide from "./pages/ProgramGuide";
import Creator from "./pages/Creator";
import Party from "./pages/Party";
import PartyRoom from "./pages/PartyRoom";
import Courses from "./pages/Courses";
import CoursePayment from "./pages/CoursePayment";
import MemberCard from "./pages/MemberCard";
import CardVerify from "./pages/CardVerify";
import { ReminderProvider } from "./components/ReminderProvider";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function App() {
  return (
    <I18nProvider>
      <ReminderProvider>
        <div className="App dark">
          <BrowserRouter>
          <Routes>
            {/* Full-screen Shorts player (no layout) */}
            <Route path="/shorts" element={<ShortsPlayer />} />
            <Route path="/shorts/:channelId" element={<ShortsPlayer />} />
            {/* All other routes wrapped by Layout */}
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/channels" element={<Channels />} />
                    <Route path="/channel/:id" element={<ChannelLive />} />
                    <Route path="/watch/:id" element={<Watch />} />
                    <Route path="/search" element={<Browse />} />
                    <Route path="/trending" element={<Trending />} />
                    <Route path="/battle" element={<Battle />} />
                    <Route path="/live" element={<LiveStream />} />
                    <Route path="/guide" element={<ProgramGuide />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/creator" element={<Creator />} />
                    <Route path="/party" element={<Party />} />
                    <Route path="/party/:code" element={<PartyRoom />} />
                    <Route path="/cours" element={<Courses />} />
                    <Route path="/cours/paiement" element={<CoursePayment />} />
                    <Route path="/cours/carte/:token" element={<MemberCard />} />
                    <Route path="/cours/verif/:token" element={<CardVerify />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/top" element={<BlogTop />} />
                    <Route path="/blog/:slug" element={<BlogArticle />} />
                    <Route path="/membership" element={<Membership />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </BrowserRouter>
        </div>
      </ReminderProvider>
    </I18nProvider>
  );
}

export default App;
